import { createMCPClient, type MCPClient } from "@ai-sdk/mcp";
import { StreamableHTTPClientTransport } from "@modelcontextprotocol/sdk/client/streamableHttp.js";
import type { ToolSet } from "./types";

/**
 * Discovers available tools from CAi's MCP gateway using @ai-sdk/mcp.
 * Uses StreamableHTTPClientTransport with a custom fetch to inject
 * dynamic MSAL tokens and app session IDs on every request.
 */
export async function discoverMcpTools(config: {
  mcpUrl: string;
  getToken: () => Promise<string>;
  getSessionId?: () => string | null;
}): Promise<{ tools: ToolSet; close: () => Promise<void> }> {
  const client = await createMCPClient({
    transport: new StreamableHTTPClientTransport(
      new URL(config.mcpUrl),
      {
        fetch: async (url, init) => {
          const token = await config.getToken();
          const headers = new Headers(init?.headers as HeadersInit);
          headers.set("Authorization", `Bearer ${token}`);

          // Pass app session ID so CAi backend can correlate RAG uploads
          const appSessionId = config.getSessionId?.();
          if (appSessionId) {
            headers.set("x-session-id", appSessionId);
          }

          return globalThis.fetch(url, { ...init, headers });
        },
      },
    ),
  });

  const tools = await client.tools();

  return {
    tools,
    close: () => client.close(),
  };
}
